import React from 'react';
import { SwiperSlide } from 'swiper/react';

import { Button } from '$partials/ui';
import { Carousel, CarouselArrowNavigation, CarouselWrapper } from '$partials/base/carousel';
import ArticleListingItem from '$partials/items/article-listing-item';
import { formatLinkBlockToUrl } from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ArticleCarouselBlock}
 */

const ArticleCarousel = ({
    articles,
    ctaLink,
    title,
    text,
    wrapperClass
}) => {
    return (
        <section className={`${wrapperClass ? wrapperClass : ''} flex flex-wrap rounded-lg bg-surface-panel-red pt-24 pb-8 md:pb-24 -mx-8 sm:-mx-8 md:-mx-16`}>
            <div className='px-4 sm:px-8 md:px-8 w-full'>
                <div className='w-full col-padding'>
                    <h2 className='type-style-sans-h1 w-full md:w-7/12'>
                        {title}
                    </h2>
                    {text && (
                        <p className='type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'>
                            {text}
                        </p>
                    )}
                </div>
            </div>

            <Carousel
                swiperConfig={{
                    a11y: { enabled: true },
                    slidesPerView: 1.2,
                    slidesOffsetBefore: 8,
                    slidesOffsetAfter: 8,
                    breakpoints: {
                        992: {
                            slidesPerView: 2.35,
                        },
                        1440: {
                            slidesPerView: 3.15,
                            slidesOffsetBefore: 16,
                            slidesOffsetAfter: 16
                        }
                    },
                    spaceBetween: 8,
                    grabCursor: false,
                }}>
                <div className='w-full col-padding flex justify-end mb-16 mt-20 md:mt-12'>
                    <div className='flex px-4 md:px-8'>
                        {ctaLink?.linkTo && (
                            <Button
                                as='a'
                                className='button-outcome'
                                href={formatLinkBlockToUrl(ctaLink)}>
                                {'View all'}
                            </Button>
                        )}
                        {/* Desktop */}
                        {articles?.length > 3 && (
                            <div className='hidden md:block ml-8 md:ml-16'>
                                <CarouselArrowNavigation />
                            </div>
                        )}
                        {/* Tablet */}
                        {articles?.length > 2 && (
                            <div className='hidden sm:block md:hidden ml-8 md:ml-16'>
                                <CarouselArrowNavigation />
                            </div>
                        )}
                    </div>
                </div>

                <CarouselWrapper>
                    {articles.map(item => {
                        if (!item?.article) { return null; }

                        return (
                            <SwiperSlide
                                aria-roledescription='slide'
                                className='select-none cursor-pointer flex flex-wrap mt-4'
                                key={item?.article?.id}
                                role='group'>
                                <ArticleListingItem {...item?.article} />
                            </SwiperSlide>
                        );
                    }).filter(Boolean)}
                </CarouselWrapper>
            </Carousel>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ArticleCarousel;
